function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}


const changeAddButtonTextMobile = () => {
  const sizeLabels = document.querySelectorAll(".variants-size label input");
  
  const sizeSelected = Array.from(sizeLabels).some(input => input.checked === true);


  if (sizeSelected === false) {
    const button = document.querySelectorAll(".add-cart-button");

    button.forEach(element => {
      element.classList.add("initial-state");
      element.textContent = "Selecciona una tallaa"
    });
  }
}

const selectPathVariant = () => {
  const variants = JSON.parse(document.querySelector('[name="variants"]').value);
  const labels = document.querySelectorAll(".label-color");
  const variantId = window.location.href.split("?variant=")[1];

  if (variantId) {
    const selectedVariant = variants.filter(variant => variant.id == variantId);

    if (selectedVariant.length > 0 && labels.length > 1) {
      const variantInput = document.querySelector(`[title="color ${selectedVariant[0].option1}"]`).parentElement;
      const slideIndex = document.querySelector(`.product-swiper-wrapper [aria-label="${variantInput.ariaLabel}"]`).dataset.swiperSlideIndex;

      const mySwiper = document.querySelector('.product-swiper').swiper;

      if(isMobile()) {
        const newIndex = parseInt(slideIndex)+1;
        mySwiper.slideTo(newIndex);
      } else {
        mySwiper.slideTo(slideIndex);
      }
      mySwiper.update();
    }
  }
}

const centerSwatchColors = () => {
  const parent = document.querySelector(".swiper-wrapper.variants-swiper-wrapper");
  const colorSliders = parent.querySelectorAll("div");
  const sizeParent = document.querySelector(".variants-size");
  const sizes = sizeParent.querySelectorAll("label");

  if(colorSliders.length <= 3) {
    parent.classList.add("j-center")
  }

  if (colorSliders.length === 1) {
    const mySwiper = document.querySelector('.product-swiper').swiper;

    swiper.destroy();

    const Newswiper = new Swiper('.product-swiper', {
      // Optional parameters
      slidesPerView: 1,
      loop: false,
      centeredSlides: true,
      simulateTouch: true,
    
      // Navigation arrows
      navigation: {
        nextEl: '.product-swiper .swiper-button-next',
        prevEl: '.product-swiper .swiper-button-prev',
      },
      thumbs: {
        swiper: swiperVariants,
      },
      breakpoints: {
        769: {
          slidesPerView: "auto",
        }
      },
      on: {
        init: function () {
          document.querySelector(".product-swiper-loader").classList.add("d-none");
        },
      },
    });
  }

  if (sizes.length >= 7) {
    sizeParent.classList.add("j-start");
  }
}

const restarSliders = (slideIndex)=> {
  const mySwiper = document.querySelector('.product-swiper').swiper;

  mySwiper.removeSlide(slideIndex);
  mySwiper.thumbs.swiper.removeSlide(slideIndex);
  mySwiper.update();
}

const validadeVariantStock = (variants, form, color) => {
  let allFalse = true;

  variants.forEach(variant => {
    if(variant.available) {
      allFalse = false
    }
  });

  if(allFalse) {
    const colorLabel = form.querySelector(`[title="color ${color}"]`);
    const carruselElement = document.querySelector(`.product-swiper .product-swiper-wrapper [aria-label="${colorLabel.parentElement.ariaLabel}"]`);

    restarSliders(carruselElement.dataset.swiperSlideIndex);
    
  }
}

const hiddeColorVariant = () => {
  const productForm = document.querySelector("#pdp_form");
  const variants = JSON.parse(document.querySelector('[name="variants"]').value);
  
  productForm.querySelectorAll(`[name="color"]`).forEach(input => {
    const color = input.value;

    const filterVariants =  variants.filter(
      variant => variant.option1 == color
    )

    validadeVariantStock(filterVariants, productForm, color);

    if(productForm.querySelectorAll(`[name="color"]`)[0].checked === false) {
      productForm.querySelectorAll(`[name="color"]`)[0].click();
      changeAddButtonTextMobile();
    }
  })

  productForm.style.opacity = 1;
}

hiddeColorVariant();
centerSwatchColors();
selectPathVariant();